import React from 'react';
import styled from "styled-components";
import Logo from "../assets/Original on Transparent.png";
import {useNavigate} from "react-router-dom";
import {device} from "../components/Devices";

function LandingPage() {

    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/home");
    }

    return (

        <Landing>


            <div>

                <h1>This site is still under construction, but feel free to already wander around to see what is
                    coming....</h1>

                <img
                    src={Logo}
                    alt=""
                    onClick={handleClick}

                />

                <button onClick={handleClick}>Enter</button>
            </div>


        </Landing>

    );
}

export default LandingPage;

const Landing = styled.div`

  margin-top: 15rem;
  display: flex;
  flex-direction: column;
  width: 320px;


  @media ${device.mobileM} {
    width: 375px;
  }

  @media ${device.mobileL} {
    width: 425px;
  }

  @media ${device.tablet} {
    width: 768px;
  }

  @media ${device.laptop} {

    width: 1024px;
  }

  @media ${device.laptopL} {
    width: 1440px;
    min-height: auto;
  }

  div {

    display: flex;
    flex-direction: column;
    align-items: center;
    width: auto;
    
    h1 {
      color: var(--mainTextColor);
      font-size: 25px;
      font-weight: lighter;
      width: 320px;
      text-align: center;
      margin-bottom: 20px;
      padding: 16px;
      border: 2px dotted var(--orange);
    }

    img {
      width: 250px;
      height: 200px;
      cursor: pointer;
    }

    button {
      width: auto;
      padding: 6px 40px;
      margin-top: 20px;
      background-color: var(--orange);
      color: var(--mainTextColor);
      border: none;
      border-radius: 5px;
    }
  }




`;